import convert from "convert-units";
import round from "lodash/round";
import React from "react";
import { RillContext } from "../../rill/RillReact/share/base";
import UnitInput from "./unit-input-add-exercise";

class ParameterInput extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      units: this.props.units,
    };

    this.handleUnitChange = this.handleUnitChange.bind(this);
  }

  handleUnitChange() {
    const { units } = this.state;
    const { id } = this.props;
    const currentUnit = units === "imperial" ? "lb" : "kg";
    const newUnit = currentUnit === "lb" ? "kg" : "lb";
    const value = document.getElementById(id).value;

    document.getElementById(id).value = round(
      convert(value).from(currentUnit).to(newUnit),
      2
    );

    this.setState({
      units: units === "imperial" ? "metric" : "imperial",
    });
  }

  render() {
    const { units } = this.state;
    const { name, onChange, tabIndex, defaultValue, id } = this.props;

    return (
      <UnitInput
        metric="kg"
        imperial="lb"
        className="text-input"
        name={name}
        placeholder="Weight"
        defaultValue={defaultValue || 0}
        id={id}
        type="text"
        onProgramEditor={true}
        onInput={(e) => {
          let { value } = e.target;
          const currentUnit = units === "imperial" ? "lb" : "kg";
          if (String(value).includes(",")) {
            value = e.target.value = String(value).replace(/,/g, ".");
          }

          // Leading +/- means a load modifier, not a weight — forward the
          // raw value as-is so the sign survives (convert()/parseFloat
          // would otherwise drop it, or NaN on a bare "-").
          if (/^[+-]/.test(String(value).trim())) {
            onChange({ target: { name, value } });
            return;
          }

          onChange({
            target: {
              name,
              value: round(convert(value).from(currentUnit).to("kg"), 2),
            },
          });
        }}
        units={units}
        handleUnitChange={this.handleUnitChange}
        min={0}
        tabIndex={tabIndex}
        unitsTabIndex={-1}
      />
    );
  }
}

ParameterInput.contextType = RillContext;

export default ParameterInput;
